import { FC, SVGAttributes } from 'react';

type MailSvgProps = SVGAttributes<SVGElement>;

export const MailSvg: FC<MailSvgProps> = ({ ...props }) => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M13.0537 4.61337C12.2737 3.83337 11.1737 3.83337 9.16699 3.83337H7.83366C5.83366 3.83337 4.72698 3.83337 3.94698 4.61337C3.16698 5.39337 3.16699 6.50004 3.16699 8.50004C3.16699 10.5 3.16698 11.6067 3.94698 12.3867C4.72698 13.1667 5.83366 13.1667 7.83366 13.1667H9.16699C11.167 13.1667 12.2737 13.1667 13.0537 12.3867C13.8337 11.6067 13.8337 10.5 13.8337 8.50004C13.8337 6.50004 13.8337 5.39337 13.0537 4.61337ZM11.467 7.76004L9.99365 8.50004C9.52699 8.73337 9.01366 8.84671 8.50033 8.84671C7.98699 8.84671 7.47367 8.73337 7.007 8.50004L5.53365 7.76004C5.20698 7.59337 5.07364 7.19337 5.23364 6.86671C5.40031 6.54004 5.80033 6.40004 6.12699 6.56671L7.60034 7.30671C8.16034 7.58671 8.827 7.58671 9.387 7.30671L10.8603 6.56671C11.1936 6.40004 11.587 6.53337 11.7537 6.86671C11.9203 7.19337 11.787 7.59337 11.4537 7.76004H11.467Z"
                fill="#828282"
            />
        </svg>
    );
};
